import { useCallback, useMemo, useState } from "react"

export function useConversationsTableSelection() {
  const [selectedKeys, setSelectedKeys] = useState<Set<string>>(new Set())
  const [runsToDelete, setRunsToDelete] = useState<string[]>([])

  const clearSelectedKeys = useCallback(() => {
    setSelectedKeys(new Set())
  }, [])

  // Selection is always available (hover-revealed checkboxes, no
  // persistent select-mode toggle), so clearing is just emptying the set.
  const handleClearSelection = clearSelectedKeys

  const handleSelectionChange = useCallback((keys: Set<string>) => {
    setSelectedKeys(new Set(keys))
  }, [])

  const restoreSelection = useCallback((keys: string[]) => {
    if (keys.length === 0) {
      return
    }

    setSelectedKeys(new Set(keys))
  }, [])

  const selectedCount = useMemo(() => selectedKeys.size, [selectedKeys])

  return {
    clearSelectedKeys,
    handleClearSelection,
    handleSelectionChange,
    restoreSelection,
    runsToDelete,
    selectedCount,
    selectedKeys,
    setRunsToDelete,
    setSelectedKeys,
  }
}
